import { Injectable } from '@angular/core';
@Injectable()

export class recursosBecas {

  // rutasPublico: string = "https://hcenteno.espoch.edu.ec:9137/rutaBecasUsuario";
  // rutasMaster: string = "https://hcenteno.espoch.edu.ec:9137/rutaBecasMaster";
  // rutasCentralPersona: string = "https://hcenteno.espoch.edu.ec:9137/rutaBecasCentral";
  // rutasMedico: string = "https://hcenteno.espoch.edu.ec:9124/rutaUsuario";
  // rutasReporte: string = "https://hcenteno.espoch.edu.ec:9137/rutaBecasReporte";

  rutasPublico: string = "https://swbecas.espoch.edu.ec/rutaBecasUsuario";
  rutasMaster: string = "https://swbecas.espoch.edu.ec/rutaBecasMaster";
  rutasReporte: string = "https://swbecas.espoch.edu.ec/rutaBecasReporte";
  rutasCentralPersona: string = "https://swbecas.espoch.edu.ec/rutaBecasCentral";
  rutasMedico: string = "https://swcentromedico.espoch.edu.ec/rutaUsuario";

  rutaGestionArchivos: string = "https://apiarchivos.espoch.edu.ec/wsrepositorio/rutaRepositorio/";
  idAplicacion: string = '12';
  claveAplicacion: string = 'B13n3st4rEstud14nt1l';
  apiKeyFirma: string = '4f6b9d9db0c69f52f8d693f5ac948e34b5a1cac04f26cd5c2845b5aef7c10360';
  hashFirma = '93b54b9e7dc8a14f3d7eb77eb506757009e4de9bcdf4d666da531dcb1340d408';
  rutaFirmaWS = 'https://apifirma.espoch.edu.ec/wsfirmaec/';
  nombreArchFirma = '520423';

  //BD - COD ESTUDIANTE - NOMBRE PERSONA QUE GENERAR CON GUIONES BAJO LOS ESPACIOS - Y EL CARGO QUE TIENE PERSONA CON GUION BAJO TAMBIEN LOS ESPACIOS
  rutaRecordAcademico = 'https://apisai.espoch.edu.ec/reportesSAI/recordacademicodecimalesgeneral/';
  RUTA_ESTUDIANTE_POSGRADO = "https://swipecacademico.espoch.edu.ec/sisipecSW/servicios/informacionmatriculadodadocedula/";

}